import { MomentumPanel } from '@/components/MomentumPanel';
import { useMeStore } from '@/store/meStore';

export function MomentumPage() {
  const momentum = useMeStore((s) => s.momentum);
  const moveRecords = useMeStore((s) => s.moveRecords);
  const interventions = useMeStore((s) => s.interventions);

  return (
    <div className="space-y-8">
      <header>
        <p className="text-[10px] font-extrabold uppercase tracking-hottr-stamp text-hottr-pink">
          Progress without punishment
        </p>
        <h1 className="mt-1 font-display text-3xl font-black uppercase tracking-hottr-display">
          Momentum
          <span className="text-hottr-pink">.</span>
        </h1>
        <p className="mt-2 max-w-md text-sm text-white/55">
          Not a streak. A hard day does not erase prior progress. Lapses are data, not failure.
        </p>
      </header>

      <MomentumPanel metrics={momentum} />

      <section>
        <h2 className="mb-3 text-[10px] font-extrabold uppercase tracking-hottr-stamp text-white/48">
          Recent Moves
        </h2>
        {moveRecords.length === 0 ? (
          <p className="text-sm text-white/48">No Moves recorded yet.</p>
        ) : (
          <ul className="space-y-2">
            {[...moveRecords].reverse().slice(0, 10).map((r) => (
              <li
                key={r.id}
                className="flex items-center justify-between rounded-sm border border-white/10 px-3 py-3 text-[13px]"
              >
                <span className="text-white/72">
                  Day {r.day} · {r.outcome}
                </span>
                <span className="text-[11px] text-white/40">
                  {new Date(r.recordedAt).toLocaleDateString()}
                </span>
              </li>
            ))}
          </ul>
        )}
      </section>

      <section>
        <h2 className="mb-3 text-[10px] font-extrabold uppercase tracking-hottr-stamp text-white/48">
          I&apos;m Close outcomes
        </h2>
        {interventions.length === 0 ? (
          <p className="text-sm text-white/48">No interventions yet.</p>
        ) : (
          <ul className="space-y-2">
            {[...interventions].reverse().slice(0, 8).map((i) => (
              <li
                key={i.id}
                className="rounded-sm border border-white/10 px-3 py-3 text-[13px] text-white/72"
              >
                <span className="font-semibold text-white">{i.triggerKey}</span>
                {' · '}
                {i.helped === true ? 'helped' : i.helped === false ? 'not really' : 'pending'}
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
